import { connectInput } from 'lib/form';
import { Select } from '../common';

const SelectField = connectInput(Select);

export default SelectField;
